import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { history } from 'routers';
import { get } from 'lodash';
import { View, Image } from '@zhike/ti-ui';
import { Modal } from '@zhike/ti-component';
import { getToken, redirectToLoginPage } from 'utils/action';
import { getUserInfo, setUserInfo, postComplete } from 'common/apis';
import { loginUrl } from 'common/config';
import Header from 'components/header';
import styles from './styles';

const search = global.location.search; // eslint-disable-line
const redirect = decodeURIComponent(search.match(new RegExp('[?#&]redirect=([^?#&]+)', 'i')) ? RegExp.$1 : '');
// type 用来区分不同版本的测评 （是否为完整版入学测评 isFull = true 是以前的写法）
const isFull = decodeURIComponent(search.match(new RegExp('[?#&]isFull=([^?#&]+)', 'i')) ? RegExp.$1 : '');
let type = decodeURIComponent(search.match(new RegExp('[?#&]type=([^?#&]+)', 'i')) ? RegExp.$1 : 0);
if (isNaN(type)) { type = 0; } else { type = type * 1; }; // eslint-disable-line
if (isFull === 'true') type = 1;

// 结束
export default class End extends Component {
  // 参数
  static propTypes = {
    params: PropTypes.object.isRequired,
    stepList: PropTypes.array.isRequired,
  };

  // 模块即将加载
  async componentWillMount() {
    const { stepList } = this.props;
    const { exerciseId, mode } = this.props.params;
    const { questionId } = stepList[0];
    Header.config({});
    if (mode === 'test') {
      /**
       * 登录后置 把完成练习 + 完善信息放在这个页面
       */
      await this.updateUserInfo();
    } else {
      setTimeout(async () => {
        await this.submit();
        setTimeout(async () => {
          history.push(`/report/${mode}/${exerciseId}/${questionId}${search}`);
        }, 300);
      }, 100);
    }
  }
  // 点击提交按钮时，判断信息是否需要完善
  async updateUserInfo() {
    const { exerciseId } = this.props.params;
    const token = getToken();
    if (!token) {
      redirectToLoginPage();
      return;
    }
    // getUserInfo 用户‘年级’信息不存在, 弹框提示
    if (!type) {
      const message = await axios({
        url: getUserInfo[1],
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          From: 1,
        },
        params: {
          token,
          exerciseId,
          fields: 'background',
        },
      });
      if (message.data.code === 'BadGateway') redirectToLoginPage();
      const gradeNum = get(message, 'data.data.background.grade');
      const background = get(message, 'data.data.background');
      if (!gradeNum) {
        Modal.show('ModalUserGrade', {
          title: '信息完善',
          background: background || {},
          params: this.props.params,
          setUserInfo,
          loginUrl,
          isUnhide: true,
        }, () => {
          Header.pauseTimer();
        }, async () => {
          // 如果传入redirect 测跳转redirect 反之则跳转到测评报告页
          this.submit();
          if (redirect) {
            global.top.location.href = redirect;
          } else {
            history.push(`/report/test/${exerciseId}${search}`);
          }
        });
      } else {
        // 如果传入redirect 测跳转redirect 反之则跳转到测评报告页
        this.submit();
        if (redirect) {
          global.top.location.href = redirect;
        } else {
          history.push(`/report/test/${exerciseId}${search}`);
        }
      }
    } else if (redirect) {
      await this.submit();
      // 如果传入redirect 测跳转redirect 反之则跳转到测评报告页
      global.top.location.href = redirect;
    } else {
      await this.submit();
      history.push(`/report/test/${exerciseId}${search}`);
    }
  }

  /**
   * 通知后端完成练习
   * */
  // 提交测试
  async submit() {
    const { exerciseId } = this.props.params;
    const search = global.location.search; // eslint-disable-line
    const source = decodeURIComponent(search.match(new RegExp('[?#&]source=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const taskId = decodeURIComponent(search.match(new RegExp('[?#&]task_id=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const pid = decodeURIComponent(search.match(new RegExp('[?#&]pid=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    if (!getToken()) {
      redirectToLoginPage();
      return;
    }
    await axios({
      url: postComplete[1],
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        From: 1,
      },
      data: {
        duration: parseInt(Header.getTime() / 1000, 10),
        exerciseId: parseInt(exerciseId, 10),
        token: getToken(),
        source,
        taskId: taskId || null,
        pid,
      },
    });
  }

  // 渲染
  render() {
    return (
      <View className={styles.container}>
        <Image
          className={styles.loading}
          src={require('./assets/save.png')}
        />
        <View className={styles.text}>正在上传答案，请稍候...</View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/end/index.js